export const DebugMenuIDs = {
  debugMenuPage: 'DebugMainMenuPage',
};
